import { useEffect, useState } from 'react';

/**
 * Debounce for the search box — the Phase 10 task list asks for 300 ms.
 *
 * The *input* stays uncontrolled by the debounce: a reader sees each keystroke
 * immediately, and only the value that drives the query and the URL lags behind. The
 * other way round produces the input that eats characters on a slow phone.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
